import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {TabbedContent} from 'shells/layout/tabbed-content';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {SectionLabel} from 'shells/typography/section-label';

import type {EditionFragment as DripEdition} from 'nutshell-graphql-types';

import type {ReportURLParams} from '../../../reports/report-types';

import {BeeEditorEmailBuilder} from '../../bee-editor/email-builder/email-builder-editor';
import {getBeeEditorStyle} from '../../editions/edition-page';

type Props = {
    activeTab: string;
    tabOptions: any[];
    edition: DripEdition | null | undefined;
    onBeeEditorContentChange: (editionId: string, json: string) => Promise<any>;
    isLoading: boolean;
    canMakeChanges: boolean;
    engagementParams?: {
        activeFilters: FilterObject[];
        onParamChange: (arg1: any, arg2: boolean) => any;
        onParamPush: (arg1: any, arg2: boolean) => any;
        urlParams: ReportURLParams<'contacts'>;
        onRemoveAllFilters: () => void;
    };
};

export function DripSequenceEditionTabContent(props: Props) {
    return (
        <div className='routed-report-content'>
            <div className='full-height'>
                {props.isLoading ? <LoadingPage /> : undefined}
                {props.edition ? (
                    <div className='full-height flex border-box gap-16'>
                        {/* @ts-expect-error */}
                        <div style={getBeeEditorStyle(props.activeTab)}>
                            {props.activeTab === 'details' ? (
                                <SectionLabel>Preview</SectionLabel>
                            ) : undefined}
                            <BeeEditorEmailBuilder
                                editionId={props.edition.id}
                                onChange={
                                    props.activeTab === 'editor' && props.canMakeChanges
                                        ? (beeContentJson, editionId: string) => {
                                              try {
                                                  return props.onBeeEditorContentChange(
                                                      editionId,
                                                      beeContentJson
                                                  );
                                              } catch {
                                                  // @ts-expect-error
                                                  window.trackJs.track(
                                                      'Drip edition tab changes failed to save'
                                                  );
                                              }
                                          }
                                        : undefined
                                }
                                marketingEmailTemplate={
                                    props.edition && props.edition.emailTemplate
                                        ? props.edition.emailTemplate.beeBodyJson
                                        : undefined
                                }
                                isPreview={props.activeTab !== 'editor'}
                                editionPreviewUrl={props.edition.viewInBrowserLink}
                            />
                        </div>
                        {/* @ts-expect-error */}
                        <TabbedContent
                            selectedTab={props.activeTab}
                            tabOptions={props.tabOptions}
                        />
                    </div>
                ) : undefined}
            </div>
        </div>
    );
}
